import React, { useEffect, useRef, useState } from "react";
import { db } from "../../../../firebase";
import { ref, onValue, update } from "firebase/database";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
  Grid,
  Modal,
  Box,
  Stack,
  useTheme,
  FormControl,
  FormHelperText,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Autocomplete,
  FormLabel,
} from "@mui/material";

import Header from "../../../../components/header/Header";
import {
  decodeTokenRefresh,
  getClientToken,
  getTokenRefresh,
  decodeClientToken,
} from "../../../../helpers/token/refreshToken";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContactlessOutlinedIcon from "@mui/icons-material/ContactlessOutlined";
import DriveEtaOutlinedIcon from "@mui/icons-material/DriveEtaOutlined";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../../theme";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import HeaderPdf from "./pdf/elements/Header";
import {
  Document,
  PDFDownloadLink,
  Page,
  StyleSheet,
} from "@react-pdf/renderer";
import GridDataTable from "./table/GridDataTable";
import DocumentName from "./pdf/elements/DocumentName";
import Rider from "./pdf/elements/Rider";
import TableRider from "./pdf/elements/TableRider";
import Contact from "./pdf/elements/Contact";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import { getAdvanceCashOrder } from "../../../../api/booking/advance";
import { GenerateOpenpayUseCase } from "../../../../api/openpay/GenerateOpenpayUseCase";
import SnackBar from "../../../../components/snackbar/SnackBar";
import { getModels } from "../../../../api/model";

import { buttonStyle } from "./style/PendingLater.style";
import "./style/booking.css";
import { Formik } from "formik";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import {
  dateFormat,
  formatDateTime,
  timeFormat,
} from "../../../../helpers/date/date";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { isSortableOperation } from "@dnd-kit/react/sortable";
import { v4 as uuidv4 } from "uuid";
import { getListCountryUseCase } from "../booking/usecases/country/GetListCountryUseCase";
import { getListTourByCountry } from "../booking/data/repository/tourRepo";
import DestinationAutocompleteField from "../booking/pages/components/DestinationAutocompleteField";
import OriginAutocompleteField from "../booking/pages/components/OriginAutocompleteField";
import OriginMapModal from "../booking/pages/components/OriginMapModal";
import OtherPersonModal from "../booking/pages/components/OtherPersonModal";
import SubRoutesModal from "../booking/pages/components/SubRoutesModal";
import {
  isSameSubRoute,
  hasConsecutiveSubRoutes,
} from "../../../../helpers/booking/subRoutes";

const createSubRoute = (name, lat, lng, id = uuidv4()) => ({
  id,
  name,
  lat,
  lng,
});

const moveItem = (list, fromIndex, toIndex) => {
  const nextList = [...list];
  const [item] = nextList.splice(fromIndex, 1);
  nextList.splice(toIndex, 0, item);
  return nextList;
};

const normalizeSubRoutes = (subRoutes = []) =>
  subRoutes
    .filter(Boolean)
    .map((subRoute) =>
      createSubRoute(
        subRoute.name ?? "",
        subRoute.lat,
        subRoute.lng,
        subRoute.id || uuidv4()
      )
    );

const isMacPlatform = () => {
  const platform = navigator.userAgentData?.platform || navigator.platform || "";
  return /mac/i.test(platform);
};

const hasTwoWords = (value) => value.trim().split(/\s+/).length >= 2;

const hasValidCoordinate = (coordinate) =>
  Number.isFinite(Number(coordinate?.lat)) &&
  Number.isFinite(Number(coordinate?.lng));

const HistoryBookingLater = ({ client }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [booking, setBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const model = ["", "Sedan", "SUV", "Minivan"];
  const currency = ["", "PEN", "USD"];
  const curren = {
    1: "PEN",
    2: "USD",
  };
  const typeTitle = {
    2: "TRASLADO",
    3: "TRANSLADO POR HORAS",
    4: "TOUR",
  };
  const [open, setOpen] = React.useState(false);
  const [uid, setUid] = useState("");
  const [bookingLater, setBookingLater] = useState([]);
  const handleClose = () => setOpen(false);

  const token = getTokenRefresh();
  const id = decodeTokenRefresh(token);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 5,
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    const starCountRef = ref(db, `bookingNow/`);
    onValue(starCountRef, (snapshot) => {
      let data = snapshot.val();
      if (data === null) return setBooking([]);

      setBooking([]);
      Object.values(data).map((book) => {
        if (book.client === id && book.booking_type != 1 && book.cotizado) {
          book.currency = curren[book.currency];
          book.fullorigin = book.origin.name;
          book.fulldestination = book.destination.name;
          setBooking((oldBooking) => [...oldBooking, book]);
        }
      });
    });
  }, []);

  //traer todos los pagos que tiene en mysql
  useEffect(() => {
    setListAdvance([]);
    if (booking.length > 0) {
      booking.map(async (item, idx) => {
        const orderNumber = item.counterBooking;
        const resp = await getAdvanceCashOrder(orderNumber);
        const data = resp.data.resp;
        if (data.length > 0) {
          const list = {
            orderNumber,
            data,
          };
          console.log(list);
          setListAdvance((oldData) => [...oldData, list]);
        }
      });
    }
  }, [booking]);
  //
  const [listAdvance, setListAdvance] = useState([]);

  const dateOpenpayFormat = () => {
    var fecha = new Date();

    var año = fecha.getFullYear();
    var mes = ("0" + (fecha.getMonth() + 1)).slice(-2); // Agregar un cero inicial si es necesario
    var dia = ("0" + fecha.getDate()).slice(-2); // Agregar un cero inicial si es necesario
    var hora = ("0" + fecha.getHours()).slice(-2); // Agregar un cero inicial si es necesario
    var minuto = ("0" + fecha.getMinutes()).slice(-2); // Agregar un cero inicial si es necesario
    var segundo = ("0" + fecha.getSeconds()).slice(-2); // Agregar un cero inicial si es necesario

    var formatoFecha =
      año + "-" + mes + "-" + dia + "T" + hora + ":" + minuto + ":" + segundo;

    return formatoFecha;
  };

  const generateOpenPayForm = async (booking) => {
    try {
      setIsLoading(true);
      const baseUrl = "https://booking.taximundo.com/client";
      // const baseUrl = "http://localhost:3001/client";
      const redirectUrl = `${baseUrl}/transfer/${booking.currency}`;

      const dataToken = getClientToken();
      const { name, lastname, phone, email } = decodeClientToken(dataToken);
      const orderID = `${booking.counterBooking}-${Date.now()}`;
      const bookingOpenPay = {
        method: "card",
        amount: Number(booking.advance),
        currency: booking.currency,
        description: `${booking.counterBooking}. PAGO POR SERVICIO DE TRANSPORTE`,
        order_id: orderID,
        confirm: "false",
        send_email: "false",
        redirect_url: redirectUrl,
        due_date: dateOpenpayFormat(), //"2023-12-09T19:22:00",
        customer: {
          name: name,
          last_name: lastname,
          phone_number: phone,
          email: email,
        },
      };

      const response = await GenerateOpenpayUseCase(bookingOpenPay);

      if (response.message === "success") {
        const paymentUrl = response.data.payment_method.url;
        const transactionId = response.data.id;
        const orderId = response.data.order_id;
        window.open(paymentUrl, "_blank");
        const openpayData = {
          transaction_id: transactionId,
          order_id: orderId,
          createBy: "B",
        };
        const fbUrl = `bookingNow/${booking.uuid}/openpay`;
        await update(ref(db, fbUrl), openpayData);
      } else {
        showSnackbar("ERROR: OPENPAY", "error");
      }
      setIsLoading(false);
      setOpen(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setOpen(false);
    }
  };

  const [openPdf, setOpenPdf] = useState(false);
  const handleOpenModal = (e) => {
    e.preventDefault();
    setOpenPdf(true);
  };
  const handleCloseModal = () => setOpenPdf(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #000",
    boxShadow: 20,
    width: "100%",
    p: 2,
    overflow: "scroll",
  };
  
  const styles = StyleSheet.create({
    page: {
      fontFamily: "Helvetica",
      fontSize: 11,
      paddingTop: 30,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 35,
      lineHeight: 1.5,
      flexDirection: "column",
    },
  });

  const [dataSelected, setDataSelected] = useState([]);

  const [tableData, setTableData] = useState(null);
  useEffect(() => {
    let total = 0;
    let discount = 0;
    let advance = 0;

    Object.values(dataSelected).map((book) => {
      console.log(book);
      total += Number(book.total);
      discount += Number(book.discount);
      advance += Number(book.advance ? book.advance : 0);
    });

    setTableData({});
    setTableData({
      id: "5df3180a09ea16dc4b95f910",
      invoice_no: "201906-28",
      company: "TAXIMUNDO",
      email: "info@taximundo.com",
      phone: "(+51) 54 200 900 - (+51) 958 200 900 - (+51) 951 200 900",
      address: "Servicios Generales Trans Mundo E.I.R.L.",
      items: dataSelected,
      igv: 0,
      total: total,
      discount,
      advance,
      peaje: 0,
      subTotal: 0,
      from: 0,
      to: 0,
    });
  }, [dataSelected]);

  const columns = [
    {
      headerName: "Pedido",
      field: "counterBooking",
      type: "string",
      headerAlign: "left",
      align: "left",
      width: 80,
      renderCell: ({ row: { counterBooking } }) => {
        return (
          <div
            style={{
              fontSize: 14,
              color: "white",
              background: "blue",
              borderRadius: 3,
              padding: 2,
            }}
          >
            {counterBooking}
          </div>
        );
      },
    },
    {
      headerName: "NOMBRE",
      field: "clientName",
      width: 130,
    },
    {
      headerName: "FECHA",
      field: "date",
      width: 80,
    },
    {
      headerName: "ORIGEN",
      field: "fullorigin",
      width: 250,
    },
    {
      headerName: "DESTINO",
      field: "fulldestination",
      width: 250,
    },
    {
      headerName: "TOTAL",
      field: "total",
      width: 100,
    },
  ];

  const [messageSnk, setMessageSnk] = useState("");
  const vertical = "top";
  const horizontal = "center";
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const handleCloseSnk = () => setStateSnk(false);

  const showSnackbar = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  const [bookItem, setBookItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [cOrigin, setCOrigin] = useState("");
  const [cDestination, setCDestination] = useState("");
  const [subRoutes, setSubRoutes] = useState([]);
  const [firebaseSubRoutesCount, setFirebaseSubRoutesCount] = useState(0);
  const [openSubRoutesModal, setOpenSubRoutesModal] = useState(false);
  const [subRouteSearch, setSubRouteSearch] = useState("");
  const [subRouteError, setSubRouteError] = useState("");
  const [, setSubRouteSelected] = useState(null);
  const [openOriginMapModal, setOpenOriginMapModal] = useState(false);
  const [openDestinationMapModal, setOpenDestinationMapModal] = useState(false);
  const [openSubRouteMapModal, setOpenSubRouteMapModal] = useState(false);
  const [subRouteMapCoordinate, setSubRouteMapCoordinate] = useState(null);
  const lastSubRouteDragOperation = useRef("");

  const [bookType, setBookType] = useState(1);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [timeEnd, setTimeEnd] = useState();
  const [persons, setPersons] = useState(0);
  const [vehicle, setVehicle] = useState(1);
  const [note, setNote] = useState("");
  const [modelApi, setModelApi] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [riderOption, setRiderOption] = useState(1);
  const [openOtherPersonModal, setOpenOtherPersonModal] = useState(false);
  const [otherPersonName, setOtherPersonName] = useState("");
  const [otherPersonPhone, setOtherPersonPhone] = useState("");
  const [otherPersonPreview, setOtherPersonPreview] = useState({
    name: "",
    phone: "",
  });

  const clearFieldError = (field) => {
    setFieldErrors((currentErrors) => {
      if (!currentErrors[field]) return currentErrors;
      const nextErrors = { ...currentErrors };
      delete nextErrors[field];
      return nextErrors;
    });
  };

  const handleRiderOptionChange = (event) => {
    const value = event.target.value;
    setRiderOption(value);
    clearFieldError("riderOption");
    if (value === 2) {
      setOpenOtherPersonModal(true);
      return;
    }
    setOtherPersonName("");
    setOtherPersonPhone("");
    setOtherPersonPreview({
      name: "",
      phone: "",
    });
  };

  const handleCloseOtherPersonModal = () => setOpenOtherPersonModal(false);
  const handleOpenOtherPersonModal = () => setOpenOtherPersonModal(true);

  const handleOtherPersonNameChange = (event) => {
    const value = event.target.value
      .toUpperCase()
      .trimStart()
      .replace(/\s+/g, " ");
    setOtherPersonName(value);
  };

  const handleOtherPersonPhoneChange = (event) => {
    setOtherPersonPhone(event.target.value.slice(0, 20));
  };

  const handleAcceptOtherPerson = () => {
    if (!hasTwoWords(otherPersonName)) {
      setFieldErrors({ otherPersonName: true });
      showSnackbar("INGRESE NOMBRE Y APELLIDO", "error");
      return;
    }
    if (!otherPersonPhone.trim()) {
      setFieldErrors({ otherPersonPhone: true });
      showSnackbar("INGRESE EL TELEFONO", "error");
      return;
    }
    setOtherPersonPreview({
      name: otherPersonName.trim(),
      phone: otherPersonPhone.trim(),
    });
    setFieldErrors({});
    handleCloseOtherPersonModal();
  };

  useEffect(() => {
    const models = async () => {
      try {
        const response = await getModels();
        const data = response.data.filter((model) => model.id);
        setModelApi(data);
      } catch (error) {
        console.log(error);
      }
    };
    models();
  }, []);

  const formatterTimePicker = (date, time) => {
    const [day, month, year] = date.split("/");
    const [hourMin, amPm] = time.split(" ");
    const [hour, minute] = hourMin.split(":");
    const realHour =
      amPm == "AM" ? hour : hour == 12 ? hour : parseInt(hour) + 12;
    return new Date(year, month - 1, day, realHour, minute);
  };

  const handSelect = async (value, setAddress, setCoordinate) => {
    const result = await geocodeByAddress(value);
    const ll = await getLatLng(result[0]);
    setAddress(value);
    setCoordinate(ll);
  };

  const destinationInputValue =
    subRoutes.length > 1 ? `${subRoutes.length} PARADAS...` : destination;

  const getDestinationRoute = () =>
    destination
      ? [createSubRoute(destination, cDestination.lat, cDestination.lng)]
      : [];

  const syncDestinationFromSubRoutes = (nextSubRoutes) => {
    const lastSubRoute = nextSubRoutes[nextSubRoutes.length - 1];
    if (!lastSubRoute) {
      setDestination("");
      setCDestination({ lat: null, lng: null });
      return;
    }
    setDestination(lastSubRoute.name);
    setCDestination({ lat: lastSubRoute.lat, lng: lastSubRoute.lng });
  };

  const handleSelectOrigin = (value) => {
    handSelect(value, setOrigin, setCOrigin);
  };

  const handleSelectOriginPoint = (address, point) => {
    setOrigin(address);
    setCOrigin(point);
  };

  const handleSelectDestination = async (value) => {
    const result = await geocodeByAddress(value);
    const ll = await getLatLng(result[0]);
    setDestination(value);
    setCDestination(ll);
    setSubRoutes([createSubRoute(value, ll.lat, ll.lng)]);
    setFirebaseSubRoutesCount(0);
  };

  const handleSelectDestinationPoint = (address, point) => {
    setDestination(address);
    setCDestination(point);
    setSubRoutes([createSubRoute(address, point.lat, point.lng)]);
    setFirebaseSubRoutesCount(0);
  };

  const handleOpenDestinationRoutes = () => setOpenSubRoutesModal(true);
  const handleCloseSubRoutesModal = () => {
    setOpenSubRoutesModal(false);
    setSubRouteSearch("");
    setSubRouteError("");
    setSubRouteSelected(null);
  };

  const addSubRoute = (nextSubRoute) => {
    setSubRoutes((currentSubRoutes) => {
      const currentStops = currentSubRoutes.length
        ? currentSubRoutes
        : getDestinationRoute();
      if (isSameSubRoute(currentStops[currentStops.length - 1], nextSubRoute)) {
        setSubRouteError("No puedes agregar dos rutas iguales seguidas.");
        return currentSubRoutes;
      }
      const nextSubRoutes = [...currentStops, nextSubRoute];
      setSubRouteError("");
      syncDestinationFromSubRoutes(nextSubRoutes);
      setFirebaseSubRoutesCount(Math.max(nextSubRoutes.length - 1, 0));
      return nextSubRoutes;
    });
    setSubRouteSearch("");
    setSubRouteSelected(null);
  };

  const handleSelectSubRoute = async (value) => {
    const result = await geocodeByAddress(value);
    const ll = await getLatLng(result[0]);
    addSubRoute(createSubRoute(value, ll.lat, ll.lng));
  };

  const handleSelectSubRoutePoint = (address, point) => {
    addSubRoute(createSubRoute(address, point.lat, point.lng));
  };

  const handleAcceptSubRoute = () => handleCloseSubRoutesModal();

  const handleRemoveSubRoute = (id) => {
    setSubRoutes((currentSubRoutes) => {
      const nextSubRoutes = currentSubRoutes.filter(
        (subRoute) => subRoute.id !== id
      );
      syncDestinationFromSubRoutes(nextSubRoutes);
      setFirebaseSubRoutesCount(Math.max(nextSubRoutes.length - 1, 0));
      return nextSubRoutes;
    });
  };

  const reorderSubRoutes = (event) => {
    if (event.canceled || !isSortableOperation(event.operation)) return;
    const { source, target } = event.operation;
    if (!target || source.id === target.id) return;
    const operationKey = `${source.id}-${target.id}`;
    if (lastSubRouteDragOperation.current === operationKey) return;
    lastSubRouteDragOperation.current = operationKey;
    setSubRoutes((currentSubRoutes) => {
      const sourceIndex = currentSubRoutes.findIndex(
        (subRoute) => subRoute.id === source.id
      );
      const targetIndex = currentSubRoutes.findIndex(
        (subRoute) => subRoute.id === target.id
      );
      if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) {
        return currentSubRoutes;
      }
      const nextSubRoutes = moveItem(currentSubRoutes, sourceIndex, targetIndex);
      if (hasConsecutiveSubRoutes(nextSubRoutes)) {
        setSubRouteError("No puedes dejar dos rutas iguales seguidas.");
        return currentSubRoutes;
      }
      setSubRouteError("");
      syncDestinationFromSubRoutes(nextSubRoutes);
      return nextSubRoutes;
    });
  };

  const handleSubRoutesDragOver = (event) => {
    reorderSubRoutes(event);
  };

  const handleSubRoutesDragEnd = (event) => {
    reorderSubRoutes(event);
    lastSubRouteDragOperation.current = "";
  };

  const getBookingDestination = () => {
    const lastSubRoute = subRoutes[subRoutes.length - 1];
    if (lastSubRoute) {
      return {
        name: lastSubRoute.name,
        lat: lastSubRoute.lat,
        lng: lastSubRoute.lng,
      };
    }

    return {
      name: destination,
      lat: cDestination.lat,
      lng: cDestination.lng,
    };
  };

  const getBookingSubRoutes = () =>
    subRoutes.slice(0, -1).map((subRoute, index) => ({
      ...subRoute,
      id: index + 1,
    }));

  const handleOpenOriginMapModal = () => {
    if (isMacPlatform() || !navigator.geolocation) {
      setOpenOriginMapModal(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const point = {
          lat: coords.latitude,
          lng: coords.longitude,
        };
        setOrigin("");
        setCOrigin(point);
        setOpenOriginMapModal(true);
      },
      () => {
        showSnackbar("No se pudo obtener la ubicacion actual", "error");
        setOpenOriginMapModal(true);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const handleCloseOriginMapModal = () => setOpenOriginMapModal(false);

  const handleOpenDestinationMapModal = () => {
    if (isMacPlatform() || !navigator.geolocation) {
      setOpenDestinationMapModal(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const point = {
          lat: coords.latitude,
          lng: coords.longitude,
        };
        setDestination("");
        setCDestination(point);
        setOpenDestinationMapModal(true);
      },
      () => {
        showSnackbar("No se pudo obtener la ubicacion actual", "error");
        setOpenDestinationMapModal(true);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const handleCloseDestinationMapModal = () =>
    setOpenDestinationMapModal(false);

  const handleOpenSubRouteMapModal = () => {
    if (isMacPlatform() || !navigator.geolocation) {
      setOpenSubRouteMapModal(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const point = {
          lat: coords.latitude,
          lng: coords.longitude,
        };
        setSubRouteSearch("");
        setSubRouteSelected(null);
        setSubRouteMapCoordinate(point);
        setOpenSubRouteMapModal(true);
      },
      () => {
        showSnackbar("No se pudo obtener la ubicacion actual", "error");
        setOpenSubRouteMapModal(true);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const handleCloseSubRouteMapModal = () => {
    setOpenSubRouteMapModal(false);
    setSubRouteMapCoordinate(null);
  };

  const checkTime = () => {
    const today = new Date();
    const { day, month, year, hour, minute } = formatDateTime(
      date.$d ?? date,
      time.$d ?? time
    );

    const dateOrder = new Date(year, month, day, hour, minute, 0);
    const diffInMillisec = dateOrder.getTime() - today.getTime();
    const diffInMin = diffInMillisec / (1000 * 60);

    if (diffInMin <= 1440) {
      showSnackbar("TODA RESERVA DEBE SER MAYOR O IGUAL A 1 DIA", "error");
      return;
    }

    return true;
  };
  
  const updateBookingLater = async (e, item) => {
    e.preventDefault();
    try {
      if (checkTime()) {
        if (riderOption === 2 && !hasTwoWords(otherPersonName)) {
          setFieldErrors({ otherPersonName: true });
          showSnackbar("INGRESE NOMBRE Y APELLIDO", "error");
          handleOpenOtherPersonModal();
          return;
        }
        if (riderOption === 2 && !otherPersonPhone.trim()) {
          setFieldErrors({ otherPersonPhone: true });
          showSnackbar("INGRESE EL TELEFONO", "error");
          handleOpenOtherPersonModal();
          return;
        }
        const refPath = `bookingNow/${item.uuid}`;
        const refDB = ref(db, refPath);

        let dateend = "";
        let timeend = "";
        if (item.booking_type == 3) {
          dateend = dateEnd.$d ? dateFormat(dateEnd.$d) : dateFormat(dateEnd);
          timeend = timeEnd.$d ? timeFormat(timeEnd.$d) : timeFormat(timeEnd);
        }
        const bookingDestination = getBookingDestination();

        if (!origin.trim() || !hasValidCoordinate(cOrigin)) {
          showSnackbar("Ingrese el Origen del servicio", "error");
          return;
        }
        if (
          !String(bookingDestination.name || "").trim() ||
          !hasValidCoordinate(bookingDestination)
        ) {
          showSnackbar("Ingrese el Destino del servicio", "error");
          return;
        }

        const data = {
          booking_type: bookType,
          origin: {
            lat: cOrigin.lat,
            lng: cOrigin.lng,
            name: origin,
          },
          destination: {
            lat: bookingDestination.lat,
            lng: bookingDestination.lng,
            name: bookingDestination.name,
          },
          subRoutes: getBookingSubRoutes(),
          date: date.$d ? dateFormat(date.$d) : dateFormat(date),
          time: time.$d ? timeFormat(time.$d) : timeFormat(time),
          dateEnd: dateend,
          timeEnd: timeend,
          persons: Number(persons) ?? 1,
          vehicle: Number(vehicle) ?? 1,
          otherPersonName:
            riderOption === 2
              ? (otherPersonPreview.name || otherPersonName).trim()
              : "",
          otherPersonPhone:
            riderOption === 2
              ? (otherPersonPreview.phone || otherPersonPhone).trim()
              : "",
          note: note.toUpperCase() ?? "",
          tour_id: tour?.tour_id ?? "",
          tour_description: tour?.tour_description ?? tour?.description ?? "",
        };
        console.log(data);
        await update(refDB, data);
        handleCloseEdit();
        showSnackbar("DATOS ACTUALIZADOS");
      }
    } catch (error) {
      console.log(error);
      showSnackbar("SELECCIONE LA FECHA Y HORA", "error");
    }
  };

  const [country, setCountry] = useState(null);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const getCountrys = async () => {
      try {
        const response = await getListCountryUseCase();
        setCountries([]);
        setCountries(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getCountrys();
  }, []);

  const [tour, setTour] = useState(null);
  const [tours, setTours] = useState([]);

  useEffect(() => {
    if (country) {
      const getListTour = async () => {
        try {
          const response = await getListTourByCountry(country.id);
          setTours([]);
          setTours(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      getListTour();
    }
  }, [country]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title={""} subtitle={t("bookings")} />
        <Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOpenModal}
            sx={{ marginRight: 1 }}
          >
            <CloudDownloadOutlinedIcon />
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
          >
            <FiberNewOutlinedIcon /> {t("create new order")}
          </Button>
        </Box>
      </Box>

      {booking.length > 0 ? (
        booking.map((booking, index) => (
          <Card key={index} sx={{ border: 1, margin: "1px -3px 2px -3px" }}>
            <CardContent>
              <Grid container>
                <Grid item xs={4} sm={6}>
                  <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                    TM-{booking.counterBooking}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={8}
                  sm={booking.booking_type === 3 ? 3 : 6}
                  textAlign={"end"}
                >
                  <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                    {booking.date} - {booking.time}
                  </Typography>
                </Grid>
                {booking.booking_type === 3 && (
                  <Grid item xs={12} sm={3} textAlign={"end"}>
                    <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                      {booking.dateEnd} - {booking.timeEnd}
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    variant="h7"
                    color={"primary"}
                    sx={{ fontWeight: "bold" }}
                  >
                    A Origen: {booking.origin.name}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Typography
                    variant="h7"
                    color={"error"}
                    sx={{ fontWeight: "bold" }}
                  >
                    B Destino: {booking.destination.name}
                  </Typography>
                </Grid>
                {(booking.subRoutes ?? booking.subRutes)?.length > 0 && (
                  <Grid item xs={12}>
                    {(booking.subRoutes ?? booking.subRutes).map(
                      (subRoute, index) => (
                        <Typography
                          key={subRoute.id ?? index}
                          variant="body2"
                          sx={{ fontWeight: "bold" }}
                        >
                          {index + 1}. {subRoute.name}
                        </Typography>
                      )
                    )}
                  </Grid>
                )}

                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Vehicle: {model[booking.vehicle]}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Persons: {booking.persons}
                  </Typography>
                </Grid>
                {(booking.otherPersonName || booking.otherPersonPhone) && (
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      Para: {booking.otherPersonName?.toUpperCase()}
                      {booking.otherPersonPhone
                        ? ` - ${booking.otherPersonPhone}`
                        : ""}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    Nota: {booking.note}
                  </Typography>
                </Grid>

                {listAdvance.length > 0 &&
                  listAdvance.map((item, index) => {
                    const check =
                      Number(booking.counterBooking) ==
                      Number(item.orderNumber);

                    if (check) {
                      return (
                        <div key={index}>
                          <div style={{ width: "100%", fontWeight: "bold" }}>
                            Adelanto:
                          </div>
                          {item.data.map((adv, idx) => {
                            return (
                              <div
                                key={idx}
                                style={{ width: "100%", fontWeight: "bold" }}
                              >
                                {idx + 1}.- {adv.currency} {adv.amount}{" "}
                                {adv.status} {adv.operation_date}
                              </div>
                            );
                          })}
                        </div>
                      );
                    }
                  })}
              </Grid>
            </CardContent>
            <CardActions sx={{ mt: -2 }}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={3} md={2}>
                  <div style={buttonStyle}>
                    <DriveEtaOutlinedIcon />
                    &nbsp;
                    {booking.openpay ? (
                      booking.openpay?.status === "pending" ? (
                        "PENDIENTE"
                      ) : (
                        <div style={{ display: "block" }}>
                          <p style={{ fontSize: 11, color: "green" }}>PAGADO</p>
                          <p style={{ fontSize: 11 }}>
                            {booking.currency} {booking.advance}
                          </p>
                        </div>
                      )
                    ) : (
                      "PENDIENTE"
                    )}
                  </div>
                </Grid>

                <Grid item xs={6} sm={3} md={2}>
                  <div style={{ ...buttonStyle, display: "block" }}>
                    <p style={{ fontSize: 11, color: "green" }}>Precio</p>
                    <p>
                      {booking.currency} {booking.total}
                    </p>
                  </div>
                </Grid>

                {booking.discount && booking.discount > 0 ? (
                  <Grid item xs={6} sm={3} md={2}>
                    <div
                      style={{
                        fontWeight: "bold",
                        background: "white",
                        borderRadius: 3,
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        textAlign: "center",
                        display: "block",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "black",
                        width: "100%",
                        height: "50px",
                        fontSize: 15,
                      }}
                    >
                      <p style={{ fontSize: 11, color: "green" }}>Descuento</p>
                      <p>
                        {booking.currency} {booking.discount}
                      </p>
                    </div>
                  </Grid>
                ) : (
                  <></>
                )}

                {booking.advance && booking.advance > 0 ? (
                  <Grid item xs={6} sm={3} md={2}>
                    <div
                      style={{
                        fontWeight: "bold",
                        background: "white",
                        borderRadius: 3,
                        borderStyle: "solid",
                        borderColor: "black",
                        borderWidth: 1,
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "black",
                        width: "100%",
                        height: "50px",
                        fontSize: 15,
                        display: "block",
                      }}
                    >
                      <p style={{ fontSize: 11, color: "green" }}>Adelanto</p>
                      <p>
                        {booking.currency} {booking.advance}
                      </p>
                    </div>
                  </Grid>
                ) : (
                  <></>
                )}

                <Grid item xs={6} sm={3} md={2}>
                  <Button
                    fullWidth
                    size="small"
                    color="info"
                    variant="contained"
                    sx={{
                      height: "50px",
                      fontWeight: "bold",
                      background: "#128C7E",
                    }}
                    href={`https://api.whatsapp.com/send?phone=+51958200900&text=*Pedido:* ${booking.counterBooking},%0A *Cliente:* ${booking.clientName},%0A *Origen:* ${booking.origin.name}, *Destino:* ${booking.destination.name} `}
                    target={"_blank"}
                    onClick={(e) => {
                      // console.log(booking.uuid);
                      setUid(booking.uuid);
                    }}
                  >
                    Consultar&nbsp;
                    <WhatsAppIcon />
                  </Button>
                </Grid>
                
                {booking.advance > 0 &&
                  booking.openpay &&
                  booking.openpay.btnPay && (
                    <Grid item xs={6} sm={3} md={2}>
                      <Button
                        fullWidth
                        size="small"
                        color="primary"
                        variant="contained"
                        sx={{ height: "50px", fontWeight: "bold" }}
                        onClick={(e) => {
                          setOpen(true);
                          setUid(booking.uuid);
                          setBookingLater(booking);
                        }}
                      >
                        PAGAR&nbsp;
                        <ContactlessOutlinedIcon />
                      </Button>

                      {/* CREAR LA FUNCIONALIDAD PARA PAGAR */}
                      <Modal open={open} onClose={handleClose}>
                        <Box sx={style}>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "bold" }}
                            textAlign={"center"}
                          >
                            PAGAR PEDIDO?
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            <Button
                              fullWidth
                              size="small"
                              color="primary"
                              variant="contained"
                              sx={{ fontWeight: "bold" }}
                              disabled={isLoading}
                              onClick={(e) => {
                                generateOpenPayForm(bookingLater);
                              }}
                            >
                              CONFIRMAR
                            </Button>
                            <Button
                              fullWidth
                              size="small"
                              color="error"
                              variant="contained"
                              sx={{ fontWeight: "bold" }}
                              onClick={(e) => {
                                setOpen(false);
                              }}
                            >
                              CANCELAR
                            </Button>
                          </Stack>
                        </Box>
                      </Modal>
                    </Grid>
                  )}

                <Grid item xs={6} sm={3} md={2}>
                  <p
                    style={{ ...buttonStyle, cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      console.log(booking);
                      setBookItem(booking);
                      setDate(dayjs(booking.date, "DD/MM/YYYY").toDate());
                      setTime(formatterTimePicker(booking.date, booking.time));
                      if (booking.booking_type == 3) {
                        setDateEnd(
                          dayjs(booking.dateEnd, "DD/MM/YYYY").toDate()
                        );
                        setTimeEnd(
                          formatterTimePicker(booking.dateEnd, booking.timeEnd)
                        );
                      }

                      setBookType(booking.booking_type);

                      if (booking.booking_type == 4) {
                        const cc = countries.filter((book) => book.id == 1);
                        setCountry(cc[0]);
                        setTour({
                          tour_id: 0,
                          description: booking.tour_description,
                        });
                      }
                      const bookingSubRoutes = normalizeSubRoutes(
                        booking.subRoutes ?? booking.subRutes ?? []
                      );
                      const destinationRoute = createSubRoute(
                        booking.destination.name,
                        booking.destination.lat,
                        booking.destination.lng
                      );

                      setOrigin(booking.origin.name);
                      setDestination(booking.destination.name);
                      setCOrigin({
                        lat: booking.origin.lat,
                        lng: booking.origin.lng,
                      });
                      setCDestination({
                        lat: booking.destination.lat,
                        lng: booking.destination.lng,
                      });
                      setSubRoutes([...bookingSubRoutes, destinationRoute]);
                      setFirebaseSubRoutesCount(bookingSubRoutes.length);
                      setSubRouteSearch("");
                      setSubRouteError("");
                      setSubRouteSelected(null);
                      setPersons(booking.persons);
                      setVehicle(booking.vehicle);
                      const currentOtherPersonName =
                        booking.otherPersonName ?? "";
                      const currentOtherPersonPhone =
                        booking.otherPersonPhone ?? "";
                      const hasOtherPerson =
                        Boolean(currentOtherPersonName) ||
                        Boolean(currentOtherPersonPhone);

                      setRiderOption(hasOtherPerson ? 2 : 1);
                      setOtherPersonName(currentOtherPersonName);
                      setOtherPersonPhone(currentOtherPersonPhone);
                      setOtherPersonPreview({
                        name: currentOtherPersonName,
                        phone: currentOtherPersonPhone,
                      });
                      setFieldErrors({});
                      setNote(booking.note);
                      handleOpenEdit();
                    }}
                  >
                    <CreateOutlinedIcon />
                    EDITAR
                  </p>
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        ))
      ) : (
        <div>{t("no_bookings")}</div>
      )}

      <Modal open={openEdit} onClose={handleCloseEdit}>
        <Box sx={style}>
          <Formik>
            {({ handleChange }) => (
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      EDITAR: {typeTitle[bookType]}
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={riderOption === 2 ? 6 : 12}>
                    <FormControl fullWidth error={!!fieldErrors.riderOption}>
                      <InputLabel>Para quien es el Servicio</InputLabel>
                      <Select
                        value={riderOption}
                        id="riderOption"
                        name="riderOption"
                        label="Para quien es el Servicio"
                        onChange={handleRiderOptionChange}
                      >
                        <MenuItem value={1}>Para Mi</MenuItem>
                        <MenuItem value={2}>Para Otra persona</MenuItem>
                      </Select>
                      {fieldErrors.riderOption && (
                        <FormHelperText>Seleccione una opcion</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {riderOption === 2 && (
                    <Grid item xs={12} sm={6}>
                      <Box
                        role="button"
                        tabIndex={0}
                        onClick={handleOpenOtherPersonModal}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            handleOpenOtherPersonModal();
                          }
                        }}
                        sx={{
                          border: "1px solid",
                          borderColor:
                            fieldErrors.otherPersonName ||
                            fieldErrors.otherPersonPhone
                              ? "error.main"
                              : "divider",
                          borderRadius: "4px",
                          minHeight: 56,
                          px: 1.5,
                          py: 0.75,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          overflow: "hidden",
                          cursor: "pointer",
                          transition: "border-color 0.2s ease",
                          "&:hover": {
                            borderColor: "primary.main",
                          },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: "bold" }}
                          noWrap
                        >
                          {otherPersonPreview.name || "NOMBRE"}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          noWrap
                        >
                          {otherPersonPreview.phone || "TELEFONO"}
                        </Typography>
                      </Box>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={12}>
                    <FormLabel>ORIGEN</FormLabel>
                    <OriginAutocompleteField
                      value={origin}
                      onChange={setOrigin}
                      onSelect={handleSelectOrigin}
                      onInputChange={handleChange("weight")}
                      onMapClick={handleOpenOriginMapModal}
                      placeholder={t("origin")}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <FormLabel>DESTINO</FormLabel>
                    <DestinationAutocompleteField
                      value={destinationInputValue}
                      onChange={setDestination}
                      onSelect={handleSelectDestination}
                      onInputChange={handleChange("weight")}
                      onInputClick={handleOpenDestinationRoutes}
                      onMapClick={handleOpenDestinationMapModal}
                      placeholder={t("destination")}
                      readOnly={subRoutes.length > 0}
                      hideRoutesIcon={subRoutes.length >= 2}
                      showAddRoutesIcon={
                        firebaseSubRoutesCount === 0 && Boolean(destination)
                      }
                    />
                  </Grid>

                  <SubRoutesModal
                    open={openSubRoutesModal}
                    onClose={handleCloseSubRoutesModal}
                    addressOrigin={origin}
                    subRutes={subRoutes}
                    subRouteSearch={subRouteSearch}
                    subRouteError={subRouteError}
                    onSubRouteSearchChange={(value) => {
                      setSubRouteSearch(value);
                      setSubRouteError("");
                      setSubRouteSelected(null);
                    }}
                    onSelectSubRoute={handleSelectSubRoute}
                    onAcceptSubRoute={handleAcceptSubRoute}
                    onRemoveSubRoute={handleRemoveSubRoute}
                    onDragOver={handleSubRoutesDragOver}
                    onDragEnd={handleSubRoutesDragEnd}
                    destinationPlaceholder={t("destination")}
                    onMapClick={handleOpenSubRouteMapModal}
                  />

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>{t("SOLICITAR")}</InputLabel>
                      <Select
                        value={bookType}
                        id="booking"
                        name="booking"
                        label={t("SOLICITAR")}
                        onChange={(e) => setBookType(e.target.value)}
                      >
                        <MenuItem value={2}>{t("later")}(reservas)</MenuItem>
                        <MenuItem value={3}>{t("perHours")}</MenuItem>
                        <MenuItem value={4}>{t("Tour")}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={2}>
                        <MobileDatePicker
                          label={t("date")}
                          inputFormat="DD/MM/YYYY"
                          name="date"
                          value={date}
                          onChange={(newValue) => {
                            setDate(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <MobileTimePicker
                          label={t("time")}
                          value={time}
                          name="timeEnd"
                          onChange={(newValue) => {
                            setTime(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </Grid>

                  {bookType == 3 && (
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={2}>
                          <MobileDatePicker
                            label={t("date")}
                            inputFormat="DD/MM/YYYY"
                            name="dateEnd"
                            value={dateEnd}
                            onChange={(newValue) => setDateEnd(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </Grid>
                  )}

                  {bookType == 3 && (
                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack spacing={3}>
                          <MobileTimePicker
                            label={t("time")}
                            value={timeEnd}
                            name="timeEnd"
                            onChange={(newValue) => setTimeEnd(newValue)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </Grid>
                  )}

                  {bookType == 4 && countries && (
                    <Grid item xs={12} sm={12}>
                      <Autocomplete
                        value={country}
                        disablePortal
                        id="select-origin"
                        onChange={(e, newValue) => {
                          setCountry(newValue);
                        }}
                        options={countries}
                        getOptionLabel={(option) => `${option.name}`}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        renderInput={(params) => (
                          <TextField {...params} label={t("PAIS")} />
                        )}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>{t("vehicle")}</InputLabel>
                      <Select
                        value={vehicle}
                        id="vehicle"
                        name="vehicle"
                        label={t("vehicle")}
                        onChange={(e) => {
                          setVehicle(e.target.value);
                        }}
                      >
                        {modelApi.map((model, index) => (
                          <MenuItem key={index} value={model.id}>
                            {t(model.name)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="outlined-basic"
                      label="PERSONAS"
                      fullWidth
                      type="number"
                      variant="outlined"
                      value={persons}
                      onChange={(e) => setPersons(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <TextField
                      id="outlined-basic"
                      label="NOTAS"
                      fullWidth
                      variant="outlined"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <Button
                      fullWidth
                      type="submit"
                      color="error"
                      variant="contained"
                      size="large"
                      sx={{ height: "100%" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleCloseEdit();
                      }}
                    >
                      CERRAR
                    </Button>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Button
                      fullWidth
                      type="submit"
                      color="primary"
                      variant="contained"
                      size="large"
                      sx={{ height: "100%" }}
                      onClick={(e) => updateBookingLater(e, bookItem)}
                    >
                      ACTUALIZAR
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Box>
      </Modal>

      <SnackBar
        stateSnk={stateSnk}
        vertical={vertical}
        horizontal={horizontal}
        duration={4000}
        handleClose={handleCloseSnk}
        severity={severity}
        messageSnk={messageSnk}
      />

      <OriginMapModal
        open={openOriginMapModal}
        onClose={handleCloseOriginMapModal}
        addressOrigin={origin}
        coordOrigin={cOrigin}
        onAddressChange={setOrigin}
        onCoordinateChange={setCOrigin}
        onLocationAccept={({ address, point }) => {
          handleSelectOriginPoint(address, point);
        }}
      />

      <OriginMapModal
        open={openDestinationMapModal}
        onClose={handleCloseDestinationMapModal}
        address={destination}
        coordinate={cDestination}
        onLocationAccept={({ address, point }) => {
          handleSelectDestinationPoint(address, point);
        }}
      />

      <OriginMapModal
        open={openSubRouteMapModal}
        onClose={handleCloseSubRouteMapModal}
        address={subRouteSearch}
        coordinate={subRouteMapCoordinate}
        onLocationAccept={({ address, point }) => {
          handleSelectSubRoutePoint(address, point);
          handleCloseSubRouteMapModal();
        }}
      />

      <OtherPersonModal
        open={openOtherPersonModal}
        onClose={handleCloseOtherPersonModal}
        otherPersonName={otherPersonName}
        otherPersonPhone={otherPersonPhone}
        onNameChange={(event) => {
          clearFieldError("otherPersonName");
          handleOtherPersonNameChange(event);
        }}
        onPhoneChange={(event) => {
          clearFieldError("otherPersonPhone");
          handleOtherPersonPhoneChange(event);
        }}
        onAccept={handleAcceptOtherPerson}
        fieldErrors={fieldErrors}
      />

      {/* MODAL PDF SELECT */}
      <Modal open={openPdf} onClose={handleCloseModal}>
        <Box
          height={"100%"}
          sx={styleModal}
          backgroundColor={colors.primary[400]}
        >
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="h5" component="h2">
                Lista
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign={"end"}>
              <button
                style={{
                  backgroundColor: "red",
                  borderRadius: 15,
                  width: 30,
                  height: 30,
                  border: "none",
                  color: "white",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseModal();
                }}
              >
                X
              </button>
            </Grid>

            {dataSelected.length > 0 && (
              <Grid item xs={12} sm={12} md={2} textAlign="end">
                <PDFDownloadLink
                  document={
                    <Document>
                      <Page size="A4" style={styles.page}>
                        <HeaderPdf />
                        {/* <Title title="Taxi Mundo PERU" /> */}
                        <Contact invoice={tableData} />
                        <DocumentName
                          title={"COTIZACION"}
                          from={tableData.from}
                          to={tableData.to}
                        />
                        <Rider invoice={tableData} />
                        <TableRider invoice={tableData} />
                      </Page>
                    </Document>
                  }
                  fileName={"detalles-reservas-taximundo.pdf"}
                >
                  <Box width={"100%"}>
                    <Button fullWidth variant="contained" color="success">
                      <PictureAsPdfIcon /> DESCARGAR
                    </Button>
                  </Box>
                </PDFDownloadLink>
              </Grid>
            )}
            <Grid item xs={12}>
              {booking.length > 0 ? (
                <GridDataTable
                  data={booking}
                  checkboxSelection={true}
                  columns={columns}
                  setDataSelected={setDataSelected}
                />
              ) : (
                <>LISTA DE RESERVAS VACIA</>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default HistoryBookingLater;
